module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori3-1a8c98f54ce8fd1ab30c4301678c5598.jpg";